import http from "../components/http";
import { Madeira } from "../interfaces/madeira.interface";

// Função para buscar todas as madeiras
export const fetchMadeiras = async (): Promise<Madeira[]> => {
  const response = await http.get(`/madeiras`);
  return response.data;
};

// Função para buscar uma madeira por ID
export const fetchMadeira = async (id: string): Promise<Madeira> => {
  const response = await http.get(`/madeiras/${id}`);
  return response.data;
};

// Função para criar uma nova madeira
export const createMadeira = async (madeira: Madeira): Promise<Madeira> => {
  let response;
  try {
    response = await http.post(`/madeiras`, madeira);
  } catch (error) {
    console.error("Erro ao criar madeira:", error);
  }
  return response?.data;
};

// Função para atualizar uma madeira existente
export const updateMadeira = async (id: string, madeira: Madeira): Promise<Madeira> => {
  const response = await http.put(`/madeiras/${id}`, madeira);
  return response.data;
};

// Função para deletar uma madeira
export const deleteMadeira = async (id: string): Promise<void> => {
  await http.delete(`/madeiras/${id}`);
};
